module.exports = __webpack_public_path__ + "media/images/icon_line_openchat-10796c244617f4a5ddd7db087d559651.svg";